module.exports = __webpack_public_path__ + "public/images/netw-choose-company-tablet.d168e8e6e1685b1e79afdfeae2e376bb.jpg";